
export default class StoresController {

	constructor (zones, Zone, Store, $state, $stateParams, $filter) {
		var translate = $filter('translate');
		var dropdown = zones.map(z => ({
			id:    z.id,
			label: z.name
		}));
		this.headers = [
			{ key: 'id',             label: '#',                           type: 'text' },
			{ key: 'name',           label: translate('NAME'),             type: 'text' },
			{ key: 'address',        label: translate('ADDRESS'),          type: 'text' },
			{ key: 'mangootrustUrl', label: translate('MANGOOTRUST_LINK'), type: 'url', formatter: url => new URL(url).hostname + decodeURIComponent(new URL(url).pathname) },
			{ key: '',               label: translate('ZONE'),             type: 'dropdown', dropdown, update: this.setStoreZone.bind(this) },
		];

		this.zones = zones;
		this.Zone = Zone;
		this.Store = Store;
		this.$state = $state;
		this.translate = translate;

		this.initActiveZone($stateParams.zoneId);
		
	}


	create () {
		this.$state.go('storeFormPage');
	}

	initActiveZone (zoneId) {
		var zone = this.zones.filter(z => +z.id === +zoneId)[0] || this.zones[0];
		if (zone) {
			this.activeZone = {
				...zone,
				stores: zone.stores.map(s => ({
					...s,
					selectedOption: zone.id
				}))
			};
		}
	}

	setActiveZone (zoneId) {
		this.$state.go('storesPage', { zoneId }, { reload: true });
	}

	createZone () {
		this.openZoneModal({
			title: this.translate('CREATE_ZONE'),
			action: (name, description) => this.Zone.create(name, description)
				.then(_ => this.setActiveZone(this.activeZone.id))
		});
	}

	editZone (zone) {
		this.openZoneModal({
			title: this.translate('EDIT_ZONE'),
			name: zone.name,
			description: zone.description,
			action: (name, description) => this.Zone.update(zone.id, name, description)
				.then(_ => this.setActiveZone(this.activeZone.id))
		});
	}

	openZoneModal (options) {
		swal({
			title: options.title,
			text: '<input'
			     +'    class="form-control"'
			     +'    style="display: block"'
			     +'    id="zone-create-name"'
			     +'    placeholder="'+this.translate('NAME')+'"'
			     +'    value="'+stringEscape(options.name || '')+'"'
			     +'/>'
			     +'<input'
			     +'    class="form-control"'
			     +'    style="display: block"'
			     +'    id="zone-create-description"'
			     +'    placeholder="'+this.translate('DESCRIPTION')+'"'
			     +'    value="'+stringEscape(options.description || '')+'"'
			     +'/>',
			html: true,
			showCancelButton: true,
			closeOnConfirm: false,
		}, confirm => {
			if (confirm) {
				var name        = document.getElementById('zone-create-name').value;
				var description = document.getElementById('zone-create-description').value;
				if (!name) {
					swal.showInputError(this.translate('NAME_MANDATORY'));
					return false;
				}
				if (!description) {
					swal.showInputError(this.translate('DESCRIPTION_MANDATORY'));
					return false;
				}
				return options.action(name, description)
					.then(_ => swal.close());
			}
			return true;
		});
	}

	removeZone (zone) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate('QUESTION_DELETE_ZONE')} "${zone.name}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => {
			if (confirm) {
				this.Zone.delete(zone.id)
					.then(_ => this.setActiveZone());
			}
		});
	}

	setStoreZone (store) {
		this.Store.move(store.id, store.selectedOption)
			.then(_ => this.setActiveZone(this.activeZone.id));
	}

}

StoresController.$inject = ['zones', 'Zone', 'Store', '$state', '$stateParams', '$filter'];




function stringEscape (str) {
	return str
		.replace(/&/, '&amp;')
		.replace(/"/, '&quot;')
		.replace(/</, '&lt;')
		.replace(/>/, '&gt;')
		;
}



// WEBPACK FOOTER //
// ./src/page/stores/stores.controller.js